<template>
    <div class="pa-5">
        <sg-loader :loading="loading" :overlay="true">

            <div class="text-body-1 py-3">
                На электронную почту <b id="masked-email">{{maskedEmail}}</b> было отправленно письмо с проверочным
                кодом.
            </div>

            <v-text-field ref="code" v-model="code" label="Код из письма" :disabled="code.length == 6" autofocus
                autocomplete="off" type="number" pattern="\d{6}" min="0" :error-messages="errorMessage"
                inputmode="numeric" maxlength="6"
                
                
                @keyup.enter.stop.prevent="checkCode" @keydown.tab.stop.prevent="checkCode"
                 />

            <v-btn class="mt-3" color="primary" depressed @click="resend">
                Выслать код повторно
            </v-btn>

        </sg-loader>

    </div>

</template>

<script>
    export default {


        props: {
            email: {
                type: String,
                required: true
            }
        },
        watch: {
            code(val) {
                if (val && val.length == 6) {
                    this.checkCode()
                }
            }
        },

        computed: {
            maskedEmail() {
                return this.maskEmail(this.email)
            }
        },

        data() {
            return {
                loading: false,

                errorMessage: null,
                code: '',
                codeRules: [
                    v => /^[0-9]{6}$/.test(v) || 'Проверочный код должен состоять из 6 цифр'
                ],

            }
        },

        methods: {

            focus() {
                this.$refs.code.focus()
            },

            maskEmail(email) {

                let [name, domen] = email.split('@')

                let maskedName = name[0] + "*".repeat(name.length - 2) + name[name.length - 1]

                return maskedName + '@' + domen

/* 
                return email */
            },

            validate() {
                return !this.codeRules.some(rule => {

                    let res = rule(this.code)
                    if (res != true) {
                        this.errorMessage = res
                        return true
                    }
                })
            },

            resend() {
                this.$emit('resend')
            },

            checkCode() {
                if (!this.validate()) return;


                this.loading = true


                this.$api.emailConfirm(this.code)
                    .then(res => {

                        return this.$store.dispatch('settings/FETCH')
                        .then( res => {
                            this.$emit('confirmed')
                        })


                        
                    })
                    .catch(error => {
                        this.code = ''
                        switch (error.code) {
                            case 10: {
                                this.errorMessage = error.message
                                this.$nextTick(() => {
                                    this.$refs.code.$refs.input.focus()
                                })
                                break;
                            }
                            default: {
                                this.$eventBus.$emit('error', error)
                                break;
                            }
                        }
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
        }



    }
</script>

<style>

</style>